<template>
  <span>
  <a class="data-table-action"
     v-if="componentEnabled && object.mphone && !rights.includes('hide_patient_phone')"
     :title="$t('call')"
     v-b-tooltip.hover
     :href="`tel:${object.mphone}`">
    <PhoneSvg/><span class="action-button-mob-title">{{ $t('call') }}</span>
  </a>
  <a :title="$t('sms_sending')"
     v-if="componentEnabled && object.mphone && !rights.includes('hide_patient_phone') && rights.includes('sms_send')"
     v-b-tooltip.hover
     class="data-table-action"
     @click="sendSms">
    <SmsSvg/><span class="action-button-mob-title">{{ $t('sms_sending') }}</span>
  </a>
    <a @click="restoreUser"
       v-if="object.blocked == 1"
       class="data-table-action">
    <RefreshSvg class="svg-light"/><span class="action-button-mob-title">{{ $t('restore') }}</span>
  </a>
    </span>
</template>

<script>

import SmsSvg from '@/assets/svg-vue/general/sms.svg'
import PhoneSvg from '@/assets/svg-vue/header/phone.svg'
import {mapState} from "vuex"
import RefreshSvg from '@/assets/svg-vue/form/tick.svg'
import {EloquentService} from "@/services/api/eloquent.api.service"

export default {
  name: "PatientDatatableActions",
  components: {
    RefreshSvg,
    PhoneSvg,
    SmsSvg,
  },
  props: {
    object: {
      type: Object
    }
  },
  data() {
    return {
      componentEnabled: false
    }
  },
  computed: {
    ...mapState({
      rights: state => state.auth.rights,
    })
  },
  methods: {
    sendSms() {
      this.$store.commit('setPatient', this.object)
      this.$nextTick(() => {
        this.$bvModal.show('patient-sms-modal')
      })
    },
    async restoreUser() {
      await EloquentService.restore('patient', this.object.id)
      this.$store.commit('incrementDataTableCounter')
      this.$noty.info(this.$t('success_message'))
    }
  }
}
</script>
